/**
 * Put text on the clipboard. The async clipboard API needs a secure context
 * (the custom domain is HTTPS; the Vite dev server is not), so the old
 * select-and-copy route stays as the fallback. False means neither worked
 * and the caller should tell the person to copy by hand.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // fall through to the textarea route
  }
  try {
    const box = document.createElement("textarea");
    box.value = text;
    box.setAttribute("readonly", "");
    box.style.position = "fixed";
    box.style.left = "-9999px";
    document.body.appendChild(box);
    box.select();
    const ok = typeof document.execCommand === "function" && document.execCommand("copy");
    box.remove();
    return ok;
  } catch {
    return false;
  }
}
